// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"iconButton-module--iconButton--6R6ln","icon":"iconButton-module--icon--1E-4U","title":"iconButton-module--title--1AtuV","col2":"iconButton-module--col2--yaIqz"};